export function formatIntlPhone(value) {
  const digits = String(value || "").replace(/\D/g, "");
  if (!digits) return "";
  const country = digits.slice(0, 2);
  const area = digits.slice(2, 4);
  const mid = digits.slice(4, 7);
  let rest = digits.slice(7);
  const parts = [country];
  if (area) parts.push(area);
  if (mid) parts.push(mid);
  if (rest) {
    if (rest.length > 4) {
      while (rest.length > 3) {
        parts.push(rest.slice(0, 3));
        rest = rest.slice(3);
      }
      if (rest) parts.push(rest);
    } else {
      parts.push(rest);
    }
  }
  return `+${parts.join(" ")}`;
}

export function compactIntlPhone(value) {
  return formatIntlPhone(value).replace(/\s/g, "");
}
